import toggleClass from 'utils/DOM/toggleClass'

function toggleMenu() {
  toggleClass('#content', 'show')
  toggleClass(document.body, 'canvas-open')
}

export default toggleMenu
